module.exports = __webpack_public_path__ + "img/Cookie_1_resize_28.e9a24acc.png";